module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.currentSkill.name,
      "customClass": "dialogWidth-1000",
      "width": "90%",
      "visible": _vm.skilldialog,
      "close-on-click-modal": false,
      "before-close": _vm.saveAlert,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.skilldialog = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-row', {
    staticClass: "pb-20"
  }, [_c('el-col', {
    staticClass: "text-center p-10 bg-lightgarg",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "el-col-20 el-col-offset-2"
  }, _vm._l((_vm.currentSkill.pageList), function(page, pageIndex) {
    return _c('span', {
      key: page.id
    }, [_c('el-button', {
      style: (page.page == _vm.currentPage ? 'text-decoration:underline; color:#13CE66' : ''),
      attrs: {
        "disabled": _vm.isDialogLoading,
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.showNextPage(_vm.currentSkill, page.page, page.id)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(page.page))])]), _vm._v("  "), (pageIndex != (_vm.currentSkill.pageList.length - 1)) ? _c('i', {
      staticClass: "el-icon-caret-right"
    }) : _vm._e(), _vm._v("  \n                                ")], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "owner"
  }, [_c('el-tag', {
    attrs: {
      "color": "white",
      "type": "success"
    }
  }, [_vm._v("owner: "), _c('b', [_vm._v(_vm._s(_vm.displayName))])])], 1)], 1), _vm._v(" "), (_vm.role == 'teacher' && _vm.pageLock) ? _c('el-main', {
    staticClass: "mb-20",
    staticStyle: {
      "border": "2px solid #dddddd",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("Locked: ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#dddddd"
    },
    on: {
      "change": function($event) {
        return _vm.switchLock(_vm.lock)
      }
    },
    model: {
      value: (_vm.lock),
      callback: function($$v) {
        _vm.lock = $$v
      },
      expression: "lock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isDialogLoading),
      expression: "isDialogLoading"
    }]
  }, _vm._l((_vm.questions), function(questionGroup, index) {
    return _c('el-card', {
      key: index,
      staticClass: "mb-20"
    }, [_vm._l((questionGroup), function(question) {
      return [_c('el-row', [_c('el-col', [_c('el-tooltip', {
        staticClass: "mb-2 mt-5",
        attrs: {
          "effect": "dark",
          "placement": "bottom",
          "disabled": question.guidance == null
        }
      }, [_c('div', {
        staticStyle: {
          "max-width": "1000px"
        },
        attrs: {
          "slot": "content"
        },
        domProps: {
          "innerHTML": _vm._s(question.guidance)
        },
        slot: "content"
      }), _vm._v(" "), _c('div', {
        staticClass: "inlineBlock"
      }, [_c('h4', {
        style: (question.highlighted ? 'background:yellow;' : ''),
        attrs: {
          "id": 'question' + question.id
        }
      }, [_c('el-tag', {
        attrs: {
          "type": "info",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(question.sequence))]), _vm._v("\n                                            " + _vm._s(question.title) + "\n                                        ")], 1)])]), _vm._v(" "), ((_vm.role == 'teacher' || _vm.role == 'ta') && !question.confirmed) ? _c('el-button', {
        attrs: {
          "type": "primary",
          "size": "mini",
          "disabled": !question.canBeConfirm,
          "loading": question.isConfirmLoading
        },
        on: {
          "click": function($event) {
            return _vm.confirm(question)
          }
        }
      }, [_vm._v("confirm")]) : _vm._e(), _vm._v(" "), (_vm.role == 'student' && question.confirmed && !question.config.forTeacher) ? _c('el-tag', {
        attrs: {
          "type": "primary",
          "color": "white"
        }
      }, [_vm._v("confirmed")]) : _vm._e(), _vm._v(" "), ((_vm.role == 'teacher' || _vm.role == 'ta') && question.confirmed) ? _c('el-button', {
        attrs: {
          "type": "danger",
          "size": "mini",
          "loading": question.isDisapproveLoading
        },
        on: {
          "click": function($event) {
            return _vm.disapprove(question)
          }
        }
      }, [_vm._v("disapprove")]) : _vm._e()], 1)], 1), _vm._v(" "), (question.config.type == 'table') ? [_c('el-row', [_c('el-col', {
        staticClass: "mt-5"
      }, [_c('el-table', {
        class: ("drag" + index),
        attrs: {
          "data": question.config.list,
          "row-key": "id"
        }
      }, _vm._l((question.config.title), function(cell, index) {
        return _c('el-table-column', {
          key: index,
          attrs: {
            "label": cell,
            "width": question.config.width === undefined ? '' : question.config.width[index]
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.list && scope.row.list[index].type == 'tableDate') ? _c('el-date-picker', {
                staticClass: "mt-5 mb-5",
                staticStyle: {
                  "width": "100%"
                },
                attrs: {
                  "format": "yyyy-MM-dd",
                  "picker-options": _vm.datepickerOptions.option1,
                  "type": "date",
                  "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                  "title": _vm.disabledTips,
                  "placeholder": "Select date"
                },
                on: {
                  "change": function($event) {
                    _vm.isDirty = true;
                  }
                },
                model: {
                  value: (scope.row.list[index].answer),
                  callback: function($$v) {
                    _vm.$set(scope.row.list[index], "answer", $$v)
                  },
                  expression: "scope.row.list[index].answer"
                }
              }) : _vm._e(), _vm._v(" "), (scope.row.list && scope.row.list[index].type == 'tableInput') ? _c('el-input', {
                staticClass: "mt-5 mb-5",
                attrs: {
                  "type": "textarea",
                  "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                  "title": _vm.disabledTips,
                  "rows": scope.row.list[index].rows
                },
                on: {
                  "change": _vm.checkQuestionInput
                },
                model: {
                  value: (scope.row.list[index].answer),
                  callback: function($$v) {
                    _vm.$set(scope.row.list[index], "answer", $$v)
                  },
                  expression: "scope.row.list[index].answer"
                }
              }) : _vm._e()]
            }
          }], null, true)
        })
      }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _vm._l((question.config.list), function(row, index) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((row), function(col, index) {
          return [(col.type == 'input') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            ref: "col",
            refInFor: true,
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "type": "textarea",
              "rows": col.rows,
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'text') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24,
              "disabled": true
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "type": "text",
              "rows": col.rows,
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'datetime') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary  mt-5"
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "yyyy-MM-dd",
              "picker-options": _vm.datepickerOptions.option1,
              "type": "date",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.date),
              callback: function($$v) {
                _vm.$set(col, "date", $$v)
              },
              expression: "col.date"
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "gary mt-5"
          }, [_vm._v(_vm._s(col.timeDescription))]), _vm._v(" "), _c('el-time-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "HH:mm:ss",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select time',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.time),
              callback: function($$v) {
                _vm.$set(col, "time", $$v)
              },
              expression: "col.time"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'date') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "yyyy-MM-dd",
              "picker-options": _vm.datepickerOptions.option1,
              "type": "date",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'checkbox') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-checkbox-group', {
            staticStyle: {
              "vertical-align": "middle"
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          }, [(col.vertical) ? _vm._l((col.list), function(cb, index) {
            return _c('p', {
              key: index
            }, [_c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "title": _vm.disabledTips,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              }
            }, [_c('span', {
              staticStyle: {
                "white-space": "normal",
                "word-wrap": "break-word",
                "vertical-align": "top",
                "display": "inline-block"
              }
            }, [_vm._v(_vm._s(cb))])])], 1)
          }) : _vm._l((col.list), function(cb, index) {
            return _c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "title": _vm.disabledTips,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              }
            })
          })], 2)], 1)]) : _vm._e(), _vm._v(" "), (col.type == 'radio') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), (col.vertical) ? _vm._l((col.list), function(lb, index) {
            return _c('p', {
              key: index
            }, [_c('el-radio', {
              staticClass: "radio mb-5",
              attrs: {
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })], 1)
          }) : _vm._l((col.list), function(lb, index) {
            return _c('el-radio', {
              key: index,
              staticClass: "radio mb-5 mt-5",
              attrs: {
                "label": lb,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })
          })], 2)]) : _vm._e()]
        })], 2)]
      }), _vm._v(" "), _c('el-row', [(question.config.more) ? _c('el-col', {
        staticClass: " mt-5",
        attrs: {
          "span": 5
        }
      }, [_c('el-button-group', [_c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "danger",
          "disabled": _vm.lock,
          "size": "mini",
          "icon": "el-icon-plus"
        },
        on: {
          "click": function($event) {
            return _vm.more(question.config.list)
          }
        }
      }), _vm._v(" "), _c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "success",
          "disabled": _vm.lock,
          "size": "mini",
          "icon": "el-icon-minus"
        },
        on: {
          "click": function($event) {
            return _vm.less(question.config.list)
          }
        }
      })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.role == 'ta' || _vm.role == 'student') ? _c('el-row', [(question.commentList && question.commentList.length != 0) ? _c('el-col', {
        staticClass: "p-10 bg-lightgarg mt-5",
        attrs: {
          "span": 24
        }
      }, [(question.showCommentCount == 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = question.commentList.length
          }
        }
      }, [_vm._v("View " + _vm._s(question.commentList.length - _vm.showCommentCount) + " more comments")]) : _vm._e(), _vm._v(" "), (question.showCommentCount != 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = 3
          }
        }
      }, [_vm._v("Hide more")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((question.commentList), function(comment, commentIndex) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (commentIndex > question.commentList.length - question.showCommentCount - 1),
            expression: "commentIndex > question.commentList.length-question.showCommentCount-1"
          }],
          key: commentIndex
        }, [_c('div', {
          staticClass: "dark  mt-5 commentContent",
          style: (comment.highlighted ? 'background:yellow;' : ''),
          attrs: {
            "id": 'comment' + comment.id
          }
        }, [_c('span', {
          staticClass: "success"
        }, [_c('b', [_vm._v(_vm._s(comment.fromName))])]), _vm._v(" : " + _vm._s(comment.content))]), _vm._v(" "), _c('div', {
          staticClass: "gary mb-2"
        }, [_vm._v(_vm._s(comment.time)), (comment.userId == _vm.userId) ? _c('el-button', {
          staticClass: "ml-5",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.cancelComment(comment, question.commentList)
            }
          }
        }, [_vm._v("remove")]) : _vm._e()], 1)])
      }), 0)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.role == 'ta' || _vm.role == 'student') ? _c('el-row', {
        staticClass: "mb-10 mt-5"
      }, [_c('el-col', {
        attrs: {
          "span": 1
        }
      }, [(!question.config.forTeacher) ? _c('el-button', {
        attrs: {
          "type": "success",
          "size": "mini"
        },
        on: {
          "click": function($event) {
            question.show = !question.show
          }
        }
      }, [_vm._v(_vm._s(question.show ? '    Hide     ' : 'Comment'))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.show),
          expression: "question.show"
        }, {
          name: "loading",
          rawName: "v-loading",
          value: (question.isSavingComment),
          expression: "question.isSavingComment"
        }],
        staticClass: "mb-10"
      }, [_c('el-col', {
        attrs: {
          "span": 20
        }
      }, [_c('el-input', {
        staticClass: "post-textarea",
        attrs: {
          "type": "textarea",
          "placeholder": "Press Ctrl + Enter to post",
          "rows": 3,
          "autofocus": "",
          "resize": "none"
        },
        on: {
          "change": _vm.checkEmoji
        },
        nativeOn: {
          "keyup": function($event) {
            return _vm.pressAction(question, question.commentList, $event)
          }
        },
        model: {
          value: (question.content),
          callback: function($$v) {
            _vm.$set(question, "content", $$v)
          },
          expression: "question.content"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('el-button', {
        staticClass: "comment-submit pt-30 pb-30 pl-30 pr-30",
        attrs: {
          "type": "success",
          "disabled": !question.content,
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.saveComment(question, question.commentList)
          }
        }
      }, [_vm._v("Post")])], 1)], 1)]
    })], 2)
  }), 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.skilldialog && !_vm.isDialogLoading),
      expression: "this.skilldialog && !isDialogLoading"
    }],
    staticClass: "fixedFooter"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveAlert(function() {
          _vm.skilldialog = false
        })
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveAnswer()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.nextPage != '') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.showNextPage(_vm.currentSkill, _vm.nextPage.page, _vm.nextPage.id)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "是否保存当前修改",
      "visible": _vm.leaveDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.leaveDialog = $event
      }
    }
  }, [_c('span', [_vm._v("如果不保存，您更改的内容将会丢失。"), _c('br'), _vm._v("Changes you made may not be saved."), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.leaveDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "danger"
    },
    on: {
      "click": _vm.unSaveAction
    }
  }, [_vm._v("Don't save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveAction
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d17f63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/ReportDialog.vue
// module id = 613
// module chunks = 1